import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fill-height pa-0 ma-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TicketZEditionWithDocument = _resolveComponent("TicketZEditionWithDocument")!
  const _component_TicketZPage = _resolveComponent("TicketZPage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isEditable)
      ? (_openBlock(), _createBlock(_component_TicketZEditionWithDocument, {
          mode: _ctx.mode,
          companyId: _ctx.companyId,
          inZTillReceipt: _ctx.zTillReceipt,
          key: _ctx.id,
          onUpdateZTill: _ctx.updateZTill,
          onDeleted: _ctx.deleted
        }, null, 8, ["mode", "companyId", "inZTillReceipt", "onUpdateZTill", "onDeleted"]))
      : _createCommentVNode("", true),
    (_ctx.isStatic)
      ? (_openBlock(), _createBlock(_component_TicketZPage, {
          mode: _ctx.mode,
          companyId: _ctx.companyId,
          inZTillReceipt: _ctx.zTillReceipt,
          key: _ctx.id,
          onDeleted: _ctx.deleted
        }, null, 8, ["mode", "companyId", "inZTillReceipt", "onDeleted"]))
      : _createCommentVNode("", true)
  ]))
}